/* global $, retailrocket, rrApi */
import Vue from "vue";

import toastr from 'toastr';
require("../vendor/prevent-double-submission");
import seguimiento from "./seguimiento"
import Carrito from "../components/Carrito.vue";

(function () {

    var $cesta = $("#ctr-cesta");
    if ($cesta.length === 0) {
        return;
    }

    seguimiento.ini();

    function mensajeError(jqXHR) {
        var texto = jqXHR.responseText;

        if(jqXHR.responseJSON && jqXHR.responseJSON.msgerror) {
            texto = jqXHR.responseJSON.msgerror;
        }
        toastr.error(texto);
    }

    var agregando = false;
    function agregar(datos, origen = '', $el = null) {
        if (agregando === true) {
            return;
        }
        agregando = true;

        if (origen === 'lista' || origen === 'form') {
            try {
                rrApi.addToBasket(datos.id)
            } catch(e) {

            }
        }

        var listaNombre = "";
        var listaId = "";
        if (origen === 'lista' && $el) {
            var $parent = $el.closest("[data-list-name][data-list-id]");
            if ($parent.length > 0) {
                listaNombre = $parent.attr("data-list-name");
                listaId = $parent.attr("data-list-id");
            }
        } else if (origen === 'retailrocket') {
            listaNombre = "Retailrocket";
            listaId = "retailrocket";
        }

        $.ajax({
            url: "/cesta/agregar",
            type: "POST",
            data: datos,
            cache: false,
            success: function(json) {
                toastr.success('Producto agregado al carrito');
                $("#cesta-nro").text(json.nro_items);
                seguimiento.agregar(json.id, json.categoria, json.marca, json.precio, json.nombre, json.cantidad, listaNombre, listaId);
            },
            error: mensajeError,
            beforeSend: function() {
                $("#cargador").show();
            },
            complete: function() {
                agregando = false;
                $("#cargador").hide();
            }
        });
    }

    let $cesteable = $(".js-cesteable");

    $cesteable.on("click", ".js-btn-comprar", function (e) {
        e.preventDefault();

        var id = $(this).attr("data-id");
        var cantidad = $(this).parents(".producto").find("input[name='cantidad']").val();

        var origen = "lista";
        if ($(this).parents("[data-retailrocket-markup-block]").length) {
            origen = "retailrocket";
        }

        agregar({id: id, cantidad: cantidad}, origen, $(this));
    });

    $cesteable.on("click", "a[data-observable]", function (e) {
        e.preventDefault();
        seguimiento.click($(this));
        window.location.href = $(this).attr("href");
    });

    $('form.cesta-agregar').preventDoubleSubmission();

    $("form.cesta-agregar").on("submit", function (e) {
        e.preventDefault();
        var id = $(this).find("input[name='id']").val();
        var cantidad = $(this).find("input[name='cantidad']").val();

        agregar({id: id, cantidad: cantidad}, 'form', $(this));
    });

    var $ctr = $("#contenedor, #buscador-resultados");

    $ctr.on("click", ".entero-asc", function () {
        var $input = $(this).parents(".ctr-button-cantidad").find('input');
        var valor = parseInt($input.val());
        valor++;
        $input.val(valor)
    });

    $ctr.on("click", ".entero-desc", function () {
        var $input = $(this).parents(".ctr-button-cantidad").find('input');
        var valor = parseInt($input.val());
        valor--;
        if (valor < 1) {
            valor = 1;
        }
        $input.val(valor)
    });

    new Vue({
        render: h => h(Carrito)
    }).$mount("#ctr-cesta");
})();